import { PtLuxonDate } from 'models/projects/date.models';

export class OnSiteMovementEditor {
  id: number;
  onSiteMovementNumber: string;

  startDate: PtLuxonDate;
  startDateConfirmed: boolean;
  endDate: PtLuxonDate;
  endDateConfirmed: boolean;

  startOffset: number;
  endOffset: number;

  legs: OnSiteMovementPerLegEditor[] = [];

  finalAirGap: number;
  reasonForJacking: string;

  lastModifiedDate: PtLuxonDate;
  lastModifiedById: number;
  lastModifiedByName: string;

  jackingEngineer1Name: string;
  jackingEngineer2Name: string;

  vesselId: number;
  vesselName: string;

  locationId: number;

  type: OnSiteMovementType;
  status: OnSiteMovementStatus;

  operationId: number;
  localOperationId: number;

  completionNotes: string;

  // Local Properties
  startDay: number;
  endDay: number;
  startDateAsDateTimeString: string;
  startDateAsTimeString: string;
  endDateAsDateTimeString: string;
  endDateAsTimeString: string;
  lastModifiedDateAsDateTimeString: string;
}

export class OnSiteMovementPerLegEditor {
  id: number;
  legNumber: number;
  load: number;
  ext: number;

  public displayOrder?: number;
}

export enum OnSiteMovementTypes {
    JackUp = 'jackup',
    JackDown = 'jackdown'
}

export class OnSiteMovementType {
    id: OnSiteMovementTypes;
    tag: string;
    name: string;
}

export enum OnSiteMovementStatuses {
    NotStarted = 'notstarted',
    InProgress = 'inprogress',
    Complete = 'complete'
}

export class OnSiteMovementStatus {
    id: OnSiteMovementStatuses;
    tag: string;
    name: string;
}



// WEBPACK FOOTER //
// ./src/models/on-site-movement/on-site-movement.models.ts